"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeFileUpload = exports.nativeFileUploadResultSchema = exports.nativeFileUploadArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.nativeFileUploadArgsSchema = zod_1.z.object({
    content: zod_1.z.string().describe('required: The content to upload as a string.'),
    mimeType: zod_1.z
        .string()
        .describe('required: The mime type of the file to upload. Defaults to "application/octet-stream".'),
    filename: zod_1.z
        .string()
        .describe('Optional custom filename for the uploaded file (without extension)')
        .nullish(),
    emitMode: common_1.emitModeSchema,
});
// Result schema
exports.nativeFileUploadResultSchema = zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.union([
        zod_1.z.literal('csv'),
        zod_1.z.literal('image'),
        zod_1.z.literal('video'),
        zod_1.z.literal('audio'),
        zod_1.z.literal('pdf'),
        zod_1.z.string(),
    ]),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
});
// Tool definition
exports.nativeFileUpload = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeFileUpload',
    displayName: 'File Upload',
    displayDescription: 'Upload a file to the server',
    category: 'native',
    color: common_1.BRAND_COLORS.FILE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.FILE),
    icon: 'upload',
    argsSchema: exports.nativeFileUploadArgsSchema,
}, exports.nativeFileUploadResultSchema);
